(function(){
  var d=document.getElementById('aps-demo'); if(!d) return;
  var q=function(s){return d.querySelector(s);}, qa=function(s){return d.querySelectorAll(s);};
  var cur=q('.d-cursor'), ins=qa('.d-in'), chips=qa('.d-chip'), tiles=qa('.tile'), btn=q('.d-btn'), keeps=qa('.d-keep .k');
  var visible=false, modeB=false;
  var sleep=function(ms){return new Promise(function(r){setTimeout(r,ms);});};
  var waitVisible=function(){return new Promise(function(r){(function c(){visible?r():setTimeout(c,300);})();});};
  function fill(){d.classList.add('photo','done');ins.forEach(function(i){var s=i.querySelector('span');s.textContent=s.getAttribute('data-type');});chips.forEach(function(c){c.classList.add('on');});tiles.forEach(function(t){t.classList.add('in');});}
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){fill();return;}
  function moveTo(el){var r=el.getBoundingClientRect(),b=d.getBoundingClientRect();cur.style.transform='translate('+(r.left-b.left+r.width*0.62)+'px,'+(r.top-b.top+r.height*0.55)+'px)';}
  async function click(){cur.classList.remove('click');void cur.offsetWidth;cur.classList.add('click');await sleep(160);}
  async function type(i){var s=i.querySelector('span'),t=s.getAttribute('data-type');i.classList.add('typing');for(var k=1;k<=t.length;k++){s.textContent=t.slice(0,k);await sleep(55);}await sleep(250);i.classList.remove('typing');}
  function reset(){d.classList.remove('photo','loading','done');ins.forEach(function(i){i.querySelector('span').textContent='';});chips.forEach(function(c){c.classList.remove('on');});tiles.forEach(function(t){t.classList.remove('in');});keeps.forEach(function(k){k.classList.remove('on');});}
  async function pickMode(b){
    var tab=q(b?'.d-tab.tb':'.d-tab.ta');
    moveTo(tab); await sleep(700); await click();
    d.classList.toggle('mb',b); await sleep(450);
  }
  async function finish(){
    for(var c=0;c<chips.length;c++){moveTo(chips[c]);await sleep(520);await click();chips[c].classList.add('on');await sleep(140);}
    moveTo(btn); await sleep(700); await click(); btn.classList.add('press'); await sleep(150); btn.classList.remove('press');
    d.classList.add('loading'); await sleep(1400); d.classList.remove('loading'); d.classList.add('done'); d.classList.remove('run');
    for(var t=0;t<tiles.length;t++){tiles[t].classList.add('in');await sleep(260);}
    await sleep(3400); d.classList.add('fade'); await sleep(450); reset(); d.classList.remove('fade'); await sleep(300);
  }
  async function run(){
    for(;;){
      await waitVisible(); reset(); d.classList.add('run'); cur.style.transform='translate(60%,85%)';
      await sleep(500);
      if(d.classList.contains('mb')!==modeB) await pickMode(modeB);
      moveTo(q('.d-drop')); await sleep(750); await click(); d.classList.add('photo'); await sleep(650);
      if(modeB){
        for(var k=0;k<keeps.length;k++){keeps[k].classList.add('on');await sleep(380);}
        await sleep(400);
      } else {
        for(var i=0;i<ins.length;i++){moveTo(ins[i]);await sleep(700);await click();await type(ins[i]);}
      }
      await finish();
      modeB=!modeB;
    }
  }
  if('IntersectionObserver' in window){new IntersectionObserver(function(es){visible=es[0].isIntersecting;},{threshold:.25}).observe(d);}else{visible=true;}
  run();
})();
